import React, { useState, useRef, useEffect } from 'react';
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { productImageUrlPrefix } from '../assets/data';

export const ProductFormImage = ({ image, index, handleRemoveOldImage }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const deleteTimer = useRef(null);

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable({ id: image.id });

  const style = {
    transition,
    transform: CSS.Transform.toString(transform),
  };

  const handleRemoveStart = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setIsDeleting(true);
    deleteTimer.current = setTimeout(() => {
      handleRemoveOldImage({ id: image.id, index: index });
    }, 50);
  };

  const handleRemoveEnd = () => {
    setIsDeleting(false);
    if (deleteTimer.current) {
      clearTimeout(deleteTimer.current);
    }
  };

  useEffect(() => {
    return () => {
      if (deleteTimer.current) {
        clearTimeout(deleteTimer.current);
      }
    };
  }, []);

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className="relative touch-none"
    >
      <img
        src={image.url}
        // src={`${image.id.startsWith("new") ? image.url : `${productImageUrlPrefix}${image.url}`}`}
        alt={`Preview ${index + 1}`}
        className="shadow-none rounded-[20px] h-[81.33px] min-h-[81.33px] p-[0px]"
        // className="shadow-none rounded-[20px] w-[65px] min-w-[65px] h-[60px] min-h-[60px] p-[0px]"
      />
      <div
        className={`absolute top-0 right-[-5px] opacity-60 hover:opacity-80 bg-red-500 text-white rounded-full w-6 h-6 flex justify-center items-center cursor-pointer ${isDeleting ? 'scale-110' : ''}`}
        onMouseDown={handleRemoveStart}
        onMouseUp={handleRemoveEnd}
        onMouseLeave={handleRemoveEnd}
        onTouchStart={handleRemoveStart}
        onTouchEnd={handleRemoveEnd}
      >
        X
      </div>
    </div>
  );
};